import { useState, useRef, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import {
  Col,
  Offcanvas,
  Row,
  Dropdown,
  Modal,
  Button,
  OverlayTrigger,
  Tooltip as TooltipMulti
} from "react-bootstrap";
import imgs from "../../Utils/assets/img/faces/5.jpg";
// import imgs from "../../"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// Solid icons
import {
  faEnvelope,
  faMessage,
  faPhone,
  faPlus,
  faSortDown,
} from "@fortawesome/free-solid-svg-icons";

import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

import {
  FaWhatsapp,
} from "react-icons/fa";
import { useGetRequest } from "../../Utils/hooks/QueryHandler";
import {
  PutRequest,
  GetRequest,
} from "../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import "../../Components/detailPage/activity.css";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
} from "chart.js";

import { EmailModal } from "../../Components/detailPage/leads/EmailModal";
import { WhatsappModal } from "../../pages/WhatsappModal";
import { baseURL } from "../../Utils/constants/constant";
import {
  checkTwilioIntegration,
  formatDate,
  getMobileNumberByType,
  getValueOrDash,
} from "../../Utils/helpers/commonhelper";
import { ContactActivity } from "../../pages/ContactActivity";
import GlobalCallModal from "../ivr/GlobalCallModal";
import TwilioIntegrationForm from "../ivr/TwilioIntegrationForm";
import DyanmicCallLog from "../ivr/DynamicCallLog";
import { IconCurrencyRupee } from "@tabler/icons-react";
import { DealDetailsCard } from "./DealDetailsComp/DealDetailsCard";
import { QuotationDetailsCard } from "./DealDetailsComp/QuotationDetailsCard";
import { PersonalDealDetails } from "./DealDetailsComp/PersonalDealDetails";
import { DealActivityPanel } from "./DealDetailsComp/DealActivityPanel";
import { ContactDetails } from "../detailPage/Contacts/ContactDetails";
import useCommonData from "../../Utils/actions/advanceFilteringAction";
import { CompanyDetails } from "../detailPage/CompanyDetails";
import nodata from "../../Utils/assets/img/leads_no_data_found.png";
import { useOutsideClickHandler } from "../../Utils/hooks/useOutsideClickHandler";

ChartJS.register(Legend, CategoryScale, LinearScale, PointElement, LineElement);

export const DealDetails = ({
  show,
  setrefetchDealsData,
  onClose,
  onDelete,
  dealId,
  pipelineStageData,
  refetchDeals,
  canEdit_canDownload,
  setSelectedStageId
}) => {
  // Session and navigation
  const [customer, setCustomer] = useLocalStorageState("customer");
  const navigate = useNavigate();
  const customerId = customer?.customer_details?.customer_id;
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;
  const loginId = customer?.customer_details?.id;
  const headers = {
    Authentication: rf,
    Authorization: token,
  };

  const extras = {
    customer,
    setCustomer,
    rf,
    navigate,
  };
  // permission setup for leads
  const permission = customer.customer_details?.permission;
  // permission for lead
  const dealPermission = permission?.filter((c) => c.module_name === "deals");
  const user_type = Number(customer.customer_details?.user_type);
  const dealGrant = {
    isView: user_type !== 1 ? Boolean(Number(dealPermission?.find((c) => c.feature_name === "deals")?.view,),) : true,
    isCreate: user_type !== 1 ? Boolean(Number(dealPermission?.find((c) => c.feature_name === "deals")?.create,),) : true,
    isEdit: user_type !== 1 ? Boolean(Number(dealPermission?.find((c) => c.feature_name === "deals")?.edit,),) : true,
    isDelete: user_type !== 1 ? Boolean(Number(dealPermission?.find((c) => c.feature_name === "deals")?.delete,),) : true,
  };

  // common advance filter api calls that will be needed everywhere
  const { company, contacts } = useCommonData({
    leadOwner: false,
    leadSource: false,
    companies: true,
    contacts: true
  })

  // Pipeline state management
  const [selectedStep, setSelectedStep] = useState(null);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);
  const [clickedStage, setClickedStage] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [reason, setReason] = useState("");

  const pipelineData = pipelineStageData?.data;

  // state for storing the selected pipeline for the won deals modal dropdown
  const [selectedPipelineId, setSelectedPipelineId] = useState("");
  const [pipelineStage, setPipelineStage] = useState([]);

  // // Dropdown state for three dots menu
  const [showDealStatusDropdown, setShowDealStatusDrop] = useState(false);
  // const actionsDropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);
  const [callLogOpen, setCallLogOpen] = useState(false);
  // previous stage tracking state
  const [previouslyCurrentStages, setPreviouslyCurrentStages] = useState(
    new Set(),
  );
  // Email modal state
  const [showEmailModal, setShowEmailModal] = useState(false);

  // WhatsApp modal state
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);

  // // Other state
  const [isCheckingTwilio, setIsCheckingTwilio] = useState(false);
  const [globalDiller, setGlobalDiller] = useState(false);
  const [showtwilioModal, setShowTwilioModal] = useState(false);
  const [quotationData, setQuotationData] = useState([]); // state for storing associated quotation

  // contact states
  const [contactId, setContactId] = useState(null)
  const [showContactDetails, setShowContactDetails] = useState(false)

  // company states
  const [companyId, setCompanyId] = useState(null)
  const [showCompanyDetails, setShowCompanyDetails] = useState(false)

  // Close dropdowns for status on outside click
  useOutsideClickHandler({
    objRef: statusDropdownRef,
    isDropdown: showDealStatusDropdown,
    setDropdown: setShowDealStatusDrop
  })

  // Handles opening email modal
  const handleOpenEmailModal = () => {
    setShowEmailModal(true);
  };

  // Handles closing email modal
  const handleCloseEmailModal = () => {
    setShowEmailModal(false);
  };

  // Check WhatsApp integration before opening modal
  const checkWhatsappIntegration = async () => {
    setShowWhatsappModal(true);
  };

  // Handles opening WhatsApp modal with integration check
  const handleOpenWhatsappModal = () => {
    checkWhatsappIntegration();
  };

  // Toggles status dropdown menu
  const toggleStatusDropdown = () => {
    if (!canEdit_canDownload) {
      toast.warning("You are not authorized for this action!");
      return;
    }
    setShowDealStatusDrop((prev) => !prev);
  };

  // Closes status dropdown
  const closeStatusDropdown = () => setShowDealStatusDrop(false);;

  const [currencyOpt, setCurrencyOpt] = useState([]);

  const handleMakeCurrentStage = async (stageId) => {
    if (!canEdit_canDownload) {
      toast.warning("You are not authorized for this action!");
      return;
    }
    if (!dealData || !stageId || stageId === currentActiveStageId) return;

    const payload = {
      stage_id: stageId,
      deal_id: dealData.id,
      customer_id: customerId,
      pipeline_id: dealData.pipeline_id,
      user_login_id: customer?.customer_details?.id,
    };

    try {
      const response = await PutRequest(
        "deals/changeDealStage/",
        payload,
        { headers },
        extras,
      );
      if (response?.status === "success") {
        toast.success("Pipeline stage updated successfully");

        // Add the previous current stage to the set of previously current stages
        setPreviouslyCurrentStages((prev) => {
          const newSet = new Set(prev);
          if (currentActiveStageId) {
            newSet.add(currentActiveStageId);
          }
          return newSet;
        });

        setClickedStage(null);
        closeWithAnimation();
        refetchDealDetails();
      } else {
        toast.error(response?.message || "Failed to update pipeline stage");
      }
    } catch (error) {
      toast.error("An error occurred while updating pipeline stage");
    }
  };

  // Handles lead status change with confirmation dialogs
  const handleStatusChange = async (status) => {
    if (!dealData) return;

    if (status === "won") {
      setConfirmAction({ type: "status", status, needsReason: false });
      setShowConfirmDialog(true);
    } else if (status === "unqualified" || status === "lost") {
      setConfirmAction({ type: "status", status, needsReason: true });
      setShowConfirmDialog(true);
    }
  };

  // Executes the confirmed status change
  const executeStatusChange = async () => {
    if (!confirmAction || !dealData) return;

    const payload = {
      deal_id: dealId,
      customer_id: customerId,
      deal_status: confirmAction.status,
      reason: confirmAction.needsReason ? reason : "",
      user_login_id: loginId,
    };
    try {
      const response = await PutRequest(
        "deals/changeDealStatus/",
        payload,
        { headers },
        extras,
      );
      if (response?.status === "success") {
        toast.success(`Deal Status Updated To ${confirmAction.status}`);
        closeStatusDropdown();
        setShowConfirmDialog(false);
        setConfirmAction(null);
        setrefetchDealsData(true);
        onClose();
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      toast.error("An error occurred while updating lead status");
    }
  };

  // for calling
  const handleGlobalCallChange = () => {
    setGlobalDiller(false);
  };

  const checkTwilio = async () => {
    if (isCheckingTwilio) return;
    setIsCheckingTwilio(true);
    try {
      const res = await checkTwilioIntegration(customerId, headers, extras);
      if (res.status === "fail" || res.success === false) {
        setShowTwilioModal(true);
      }
      if (res.status === "success") {
        setGlobalDiller(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsCheckingTwilio(false);
    }
  };

  // Closes confirmation dialog
  const closeConfirmDialog = () => {
    setShowConfirmDialog(false);
    setConfirmAction(null);
    setReason("");
  };

  // Handles pipeline step animation close
  const closeWithAnimation = () => {
    setIsAnimatingOut(true);
    setTimeout(() => {
      setSelectedStep(null);
      setIsAnimatingOut(false);
    }, 300);
  };

  // Fetch lead details using the API
  const {
    data: dealDetailsResponse,
    isLoading: isLeadLoading,
    refetch: refetchDealDetails,
  } = useGetRequest(
    `deals/getDealDetails/${dealId}/${customerId}`,
    "fetchDealDeatils",
    headers,
    extras,
    {
      enabled: !!dealId && !!customerId && show,
    },
  );

  // useeffect for fetching pipeline stage based on the pipeline id and hydrating it in the won deals dropdown modal
  const pipelineStageUrl = selectedPipelineId
    ? `lead/fetchPipelineStage/${selectedPipelineId}/${customerId}`
    : null;

  // Fetch pipeline stages for selected pipeline
  const { data: stageData } = useGetRequest(
    pipelineStageUrl,
    ["stageDataInDetails", selectedPipelineId, customerId], // 👈 added dependencies
    headers,
    extras,
  );

  useEffect(() => {
    if (stageData?.data?.length > 0) {
      const stageDataToStore = stageData.data.map((s) => ({
        value: s.id,
        label: s.stage_name,
      }));
      setSelectedStageId("");
      setPipelineStage(stageDataToStore);
    } else {
      setPipelineStage([]);
    }
  }, [stageData]);

  // Add this useEffect to refetch when dealId changes
  useEffect(() => {
    if (dealId && customerId && show) {
      refetchDealDetails();
    }
  }, [dealId, customerId, show, refetchDealDetails]);



  // Extract lead data from API response
  const dealData = dealDetailsResponse?.data || null;
  // Find current active stage based on pipeline_stage_id
  const currentActiveStage = pipelineData?.find(
    (stage) => stage.id === dealData?.pipeline_stage_id?.toString(),
  );
  const currentActiveStageId = currentActiveStage?.id;

  // useeeffect for fetching currency value dropdown.
  useEffect(() => {
    (async () => {
      const res = await GetRequest(
        `deals/fetchActiveCurrency/${customerId}`,
        { headers },
        extras,
      );
      if (res.status === "fail" || res.success === false) {
        return;
      }

      const currencyOptions =
        res.data &&
        res.data
          ?.map((item) => {
            try {
              // Parse the currency string to object
              const currencyObj = JSON.parse(item.currency);

              // Create React Select option
              return {
                value: item.id, // Using the item's id as value
                label: `${currencyObj.label} (${currencyObj.value})`, // Format: "Chilean Peso (CLP)"
              };
            } catch (error) {
              console.error("Error parsing currency:", error);
              return null;
            }
          })
          .filter((option) => option !== null); // Remove any null entries from failed parsing

      setCurrencyOpt(currencyOptions);
    })();
  }, []);


  if (!show) return null;

  // Show loading state
  if (isLeadLoading) {
    return (
      <div className="d-flex w-100">
        <Offcanvas
          className="w-100"
          placement="end"
          backdrop="static"
          show={show}
          onHide={onClose}
          style={{ padding: "0px" }}
        >
          <Offcanvas.Body>
            <div
              className="h-100 pt-4 d-flex justify-content-center align-items-center"
              style={{ borderRadius: "15px", background: "#f9f9f9" }}
            >
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading lead details...</p>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    );
  }

  // states to be reset when the contact offcanvas is being closed
  const onContactCanvasClose = () => {
    setShowContactDetails(false)
    refetchDealDetails()
  }

  // states to be reset when the company offcanvas is being closed
  const onCompanyCanvasClose = () => {
    setShowCompanyDetails(false)
    refetchDealDetails()
  }

  return (
    <div className="d-flex w-100">
      <Offcanvas
        className="w-100"
        placement="end"
        backdrop="static"
        show={show}
        onHide={onClose}
        style={{ padding: "0px" }}
      >
        <Offcanvas.Body className="p-0">
          <div
            className="h-100 pt-4"
            style={{ borderRadius: "15px", background: "#f9f9f9" }}
          >
            <Row className="ms-0 w-100 h-100 pe-2 ps-2">
              <Col
                md={7}
                style={{
                  height: "100%",
                  overflow: "auto",
                  borderRadius: "5px",
                  borderRight: "1px solid #e0e4f8",
                  borderTop: "none",
                }}
                className="pt-0 detailsDivs p-0"
              >
                <div
                  className="me-0 pe-2"
                  style={{
                    background: "transparent",
                    paddingTop: "0px",
                    borderRadius: "0px",
                    marginBottom: "10px",
                  }}
                >
                  {/* Header Section with Lead Info */}
                  <div
                    className="d-flex gap-3 align-items-center ps-3 mb-0 me-1"
                    style={styles.stickyHeader}
                  >
                    <div>
                      <div
                        className="rounded-circle overflow-hidden border border-3 d-flex justify-content-center align-items-center"
                        style={{
                          width: "70px",
                          height: "70px",
                          backgroundColor: "#fff",
                          borderColor: "#7a3a5e",
                        }}
                      >
                        <img
                          src={
                            dealData?.contact_image
                              ? `${baseURL}${dealData.contact_image}`
                              : imgs
                          }
                          alt=""
                          className="w-100 h-100"
                          style={{ borderRadius: "50%" }}
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        color: "#576f91",
                        fontSize: "13px",
                        fontWeight: 500,
                        width: "-webkit-fill-available",
                      }}
                      className="d-flex justify-content-between pe-3"
                    >
                      <div>
                        <h4
                          className="mb-1"
                          style={{
                            fontSize: "20px",
                            fontWeight: "500",
                            color: "#3c3c3c",
                          }}
                        >
                          {getValueOrDash(dealData?.deal_name)}
                          <span style={{ color: "#3f97fd" }}>
                            ({`#${getValueOrDash(dealData?.deal_no)}`})
                          </span>
                          <span
                            style={{
                              color: "#FFC107",
                              fontSize: 13,
                              marginLeft: 7,
                            }}
                          >
                            {[...Array(5)].map((_, index) => {
                              const rating = dealData?.rating || 0;
                              if (rating >= index + 1) {
                                return <FaStar key={index} />;
                              } else if (rating >= index + 0.5) {
                                return <FaStarHalfAlt key={index} />;
                              } else {
                                return <FaRegStar key={index} />;
                              }
                            })}
                          </span>
                        </h4>
                        <p className="mb-0 d-flex align-items-center ">
                          ₹ {getValueOrDash(dealData?.total_budget) == '-' ? getValueOrDash(dealData?.total_budget) : 0}
                        </p>
                      </div>
                      <div className="d-flex flex-column position-relative">
                        <div
                          className="d-flex gap-1"
                          style={{ marginTop: "-12px" }}
                        >
                          <Tooltip title="Send WhatsApp" placement="top">
                            <button
                              type="button"
                              className="btn btn-whatsapp p-2"
                              style={styles.listWhatsButtonsStyles}
                              onClick={handleOpenWhatsappModal}
                            >
                              <FaWhatsapp style={{ fontSize: "16px" }} />
                            </button>
                          </Tooltip>
                          <div style={styles.emptyDivs}></div>
                          <Tooltip title="Send Mail" placement="top">
                            <button
                              type="button"
                              className="btn btn-primary btnss"
                              style={styles.listWhatsButtonsStyles}
                              onClick={handleOpenEmailModal}
                            >
                              <FontAwesomeIcon
                                icon={faEnvelope}
                                style={styles.iconStyles}
                              />
                            </button>
                          </Tooltip>
                          <Tooltip title="Call" placement="top">
                            <button
                              type="button"
                              className="btn btn-primary btnss"
                              style={styles.listWhatsButtonsStyles}
                              onClick={() => checkTwilio()}
                            >
                              <FontAwesomeIcon
                                icon={faPhone}
                                style={styles.iconStyles}
                              />
                            </button>
                          </Tooltip>
                          <Tooltip title="Send SMS" placement="top">
                            <button
                              type="button"
                              className="btn btn-primary btnss"
                              style={styles.listWhatsButtonsStyles}
                            >
                              <FontAwesomeIcon
                                icon={faMessage}
                                style={styles.iconStyles}
                              />
                            </button>
                          </Tooltip>
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            top: "1.2rem",
                            right: "0rem",
                            fontSize: "2.5rem",
                            color: "#c4c1c1",
                            fontWeight: 400,
                          }}
                        >
                          DEAL
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="my-3 bg-white me-1"
                    style={{
                      border: "1px solid rgb(224, 228, 248)",
                      borderRadius: 4,
                      padding: 13,
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h5
                        style={{ fontWeight: 300, fontSize: 19 }}
                        className="mb-0"
                      >
                        <p className="mb-1 fs-19" style={styles.labels}>
                          Current Pipeline
                        </p>{" "}
                        {dealData?.pipeline_name}{" "}
                      </h5>
                      <div
                        ref={statusDropdownRef}
                        className="mb-0 position-relative"
                      >
                        <button
                          className="btn-default btn d-flex gap-2"
                          style={{ fontSize: 12, borderRadius: 3, textTransform: "capitalize" }}
                          onClick={toggleStatusDropdown}
                        >
                          {dealData?.deal_status &&
                            dealData.deal_status !== "inprogress"
                            ? getValueOrDash(dealData.deal_status)
                            : "Select Deal Status"}{" "}
                          <FontAwesomeIcon icon={faSortDown} />
                        </button>
                        {showDealStatusDropdown && (
                          <div
                            className="defaultDropdown dropdown-menu"
                            style={{
                              width: "10rem",
                              padding: "7px 0px",
                              display: "block",
                              position: "fixed",
                              top:
                                statusDropdownRef.current?.getBoundingClientRect()
                                  .bottom + window.scrollY || 0,
                              left:
                                statusDropdownRef.current?.getBoundingClientRect()
                                  .right -
                                159 +
                                window.scrollX || 0,
                              zIndex: 9999,
                              backgroundColor: "#fff",
                              border: "1px solid #dee2e6",
                              borderRadius: "0.375rem",
                              boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
                            }}
                          >
                            <Dropdown.Item
                              onClick={() => {
                                if (!dealGrant.isEdit) {
                                  toast.warning(
                                    "You are not authorized for this action!",
                                  );
                                  return;
                                }
                                handleStatusChange("won");
                              }}
                              className="fs-13 d-flex gap-2 align-items-center"
                            >
                              <i
                                class="fa-solid fa-circle-check"
                                style={{ color: "#00b894" }}
                              ></i>{" "}
                              Won
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                if (!dealGrant.isEdit) {
                                  toast.warning(
                                    "You are not authorized for this action!",
                                  );
                                  return;
                                }
                                handleStatusChange("unqualified");
                              }}
                              className="fs-13 d-flex gap-2 align-items-center"
                            >
                              <i
                                class="fa-solid fa-circle-xmark"
                                style={{ color: "#d63031" }}
                              ></i>{" "}
                              Unqualified
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                {
                                  if (!dealGrant.isEdit) {
                                    toast.warning(
                                      "You are not authorized for this action!",
                                    );
                                    return;
                                  }
                                  handleStatusChange("lost");
                                }
                              }}
                              className="fs-13 d-flex gap-2 align-items-center"
                            >
                              <i
                                class="fa-solid fa-circle-exclamation"
                                style={{ color: "#fdcb6e" }}
                              ></i>{" "}
                              Lost
                            </Dropdown.Item>
                          </div>
                        )}
                      </div>
                    </div>
                    <hr />

                    <div className="arrow-steps">
                      {pipelineData?.map((stage, index) => {
                        const isActive = stage.id === currentActiveStageId;
                        const isClicked = clickedStage === stage.id;
                        const wasPreviouslyCurrent =
                          previouslyCurrentStages.has(stage.id);

                        let backgroundColor = ""; // Default gray for inactive stages
                        let textColor = "#000"; // Default text color

                        if (isActive) {
                          backgroundColor = "#7a3a5e"; // Purple for active
                          textColor = "#fff";
                        } else if (isClicked) {
                          backgroundColor = "#7a3a5e"; // Purple for clicked
                          textColor = "#fff";
                        } else if (wasPreviouslyCurrent) {
                          backgroundColor = "#28a745"; // Green for previously current stages
                          textColor = "#fff";
                        }

                        return (
                          <div
                            key={stage.id}
                            className={`step ${isActive ? "current" : ""}`}
                            onClick={() => {
                              setSelectedStep(stage.stage_name);
                              setClickedStage(stage.id);
                            }}
                            style={{
                              backgroundColor,
                              color: textColor,
                              cursor: "pointer",
                            }}
                          >
                            {stage.stage_name}
                          </div>
                        );
                      })}
                    </div>
                    {selectedStep && (
                      <div
                        className={`d-flex align-items-start bg-white animated-fade-in ${isAnimatingOut ? "fade-out" : "fade-in"}`}
                        style={{ marginTop: 10, padding: "14px 6px" }}
                      >
                        <div
                          className="d-flex gap-3 ps-2"
                          style={{ width: "83%" }}
                        >
                          <div style={{ minWidth: "120px" }}>
                            <p
                              className="mb-0 text-nowrap"
                              style={styles.labels}
                            >
                              Stage name
                            </p>
                            <p className="mb-0" style={styles.values}>
                              {selectedStep}
                            </p>
                          </div>
                          <div>
                            <p className="mb-0" style={styles.labels}>
                              Description
                            </p>
                            <p className="mb-0" style={styles.values}>
                              {pipelineData.find(
                                (stage) => stage.stage_name === selectedStep,
                              )?.stage_description || "-"}
                            </p>
                          </div>
                        </div>
                        {clickedStage !== currentActiveStageId && (
                          <button
                            className="btn btn-default me-0"
                            style={{
                              fontSize: "13px",
                              textWrap: "nowrap",
                              color: "#fff",
                            }}
                            onClick={() => {
                              if (!dealGrant?.isEdit && !canEdit_canDownload) {
                                toast.warning(
                                  "You are not authorized for this action!",
                                );
                                return;
                              }
                              const selectedStageData = pipelineData.find(
                                (stage) => stage.stage_name === selectedStep,
                              );
                              if (selectedStageData) {
                                handleMakeCurrentStage(selectedStageData.id);
                              }
                            }}
                          >
                            Make as Current
                          </button>
                        )}
                      </div>
                    )}
                  </div>

                  <div
                    style={{ marginTop: 10 }}
                    className="d-flex gap-2 align-items-stretch"
                  >
                    {/* Left Column - Personal Details */}
                    {/* contact, company, internal and social details of the associated contact to deal */}
                    <PersonalDealDetails
                      dealData={dealData}
                      setContactId={setContactId}
                      setShowContactDetails={setShowContactDetails}
                      setCompanyId={setCompanyId}
                      setShowCompanyDetails={setShowCompanyDetails}
                    />

                    {/* Right Column - Pipeline, Chart, History */}
                    <div
                      style={{
                        height: "100%",
                        width: "50%",
                        position: "relative",
                      }}
                      className="pt-0 p-0 pe-1"
                    >

                      {/* deal details */}
                      <DealDetailsCard dealData={dealData} />

                      {/* Quotation Details */}
                      <QuotationDetailsCard dealData={dealData} dealId={dealId} headers={headers} extras={extras} customerId={customerId} />

                      {/* History Section - Keep existing */}
                      <div
                        className="mt-3"
                        style={{
                          background: "#fff",
                          border: "1px solid rgb(224, 228, 248)",
                          borderRadius: 5,
                          height: "38.5rem",
                        }}
                      >
                        <h3
                          style={styles.sectionTitle}
                          className="d-flex mt-3 justify-content-between align-items-center"
                        >
                          History
                        </h3>
                        <hr className="my-2" />
                        <div
                          style={{ paddingLeft: "15px", paddingTop: "15px" }}
                        >

                          {dealData?.id && <ContactActivity
                            module_id={dealData?.id}
                            module_name={"deal"}
                            headers={headers}
                            extras={extras}
                          />}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </Col>

              {/* Right Panel - Tabs Section */}
              <DealActivityPanel
                headers={headers}
                extras={extras}
                onClose={onClose}
                dealGrant={dealGrant}
                individualDealData={dealData}
                dealId={dealId}
                canEdit_canDownload={canEdit_canDownload}
                setCallLogOpen={setCallLogOpen}
                refetchDealDetails={refetchDealDetails}
                refetchDeals={refetchDeals}
                setSelectedStageId={setSelectedStageId}
                isActionDropReqd={true}
              />
            </Row>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {
        showContactDetails && contactId !== null &&
        <ContactDetails
          show={showContactDetails}
          setShowContactDetailsCanvas={setShowContactDetails}
          onlyDetail={true}
          id={contactId}
          allContacts={contacts}
          onCanvasClose={onContactCanvasClose}
        />
      }

      {showCompanyDetails && companyId !== null &&
        <CompanyDetails
          show={showCompanyDetails}
          onCanvasClose={onCompanyCanvasClose}
          id={companyId}
          allCompanies={company}
          setShowCompanyDetails={setShowCompanyDetails}
          onlyDetails={true}
        />
      }

      {/* Email Modal */}
      <EmailModal
        show={showEmailModal}
        onClose={handleCloseEmailModal}
        id={dealId}
        pipelineId={dealData?.pipeline_id}
        customerId={customerId}
        loginId={loginId}
        headers={headers}
        extras={extras}
        data={dealData} // Pass lead data for pre-populating emails
      />
      {/* WhatsApp Modal */}
      {
        showWhatsappModal && (
          <WhatsappModal
            whatsappModalOpen={showWhatsappModal}
            setWhatsAppModalOpen={setShowWhatsappModal}
            id={dealId}
            module_name={"leads"}
          />
        )
      }

      {/* {modal for call log} */}
      {
        callLogOpen && (
          <DyanmicCallLog
            show={callLogOpen}
            onCloseModal={() => setCallLogOpen(false)}
            module_id={dealId}
            module_name={"deal"}
          />
        )
      }
      {
        showtwilioModal && (
          <TwilioIntegrationForm
            isOpen={showtwilioModal}
            onClose={() => setShowTwilioModal(false)}
          />
        )
      }
      {/* global */}
      {
        globalDiller && (
          <GlobalCallModal
            isOpen={globalDiller}
            customerId={customerId}
            loginUserId={customer?.customer_details?.id}
            phoneNumber={getMobileNumberByType(dealData?.user_phone, "Mobile")}
            onClose={handleGlobalCallChange}
            module_name={"deal"}
            module_id={dealId}
          />
        )
      }
      {/* Confirmation Dialog Modal */}

      {
        showConfirmDialog && (
          <Modal
            show={true}
            onHide={closeConfirmDialog}
            centered
            backdrop="static"
            style={{ zIndex: 1055 }}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {confirmAction?.status === "won"
                  ? "Confirm Win"
                  : `Confirm ${confirmAction?.status}`}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="d-flex flex-column gap-3">
                <p className="mb-0">
                  {confirmAction?.status === "won" ? (
                    "This action cannot be undone. Are you sure?"
                  ) : (
                    <>
                      Are you sure you want to mark this lead as{" "}
                      <span className="text-capitalize fw-medium">
                        {confirmAction?.status}
                      </span>
                      ? This action cannot be undone.
                    </>
                  )}
                </p>

                {confirmAction?.needsReason && (
                  <div className="mb-3">
                    <label className="form-label fw-semibold">Reason *</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      placeholder={`Please provide a reason for marking as ${confirmAction?.status}`}
                      required
                      style={{ resize: "vertical" }}
                      autoFocus
                    />
                  </div>
                )}
              </div>
            </Modal.Body>

            <Modal.Footer className="d-flex justify-content-end gap-2">
              <button
                className="btn btn-default-outline"
                onClick={closeConfirmDialog}
              >
                Cancel
              </button>
              <button
                className="btn btn-default"
                onClick={executeStatusChange}
                disabled={confirmAction?.needsReason && !reason.trim()}
              >
                Confirm
              </button>
            </Modal.Footer>
          </Modal>
        )
      }
    </div >
  );
};

const styles = {
  bottomP: {
    fontSize: 11,
  },
  bottomH4: {
    marginBottom: 2,
  },
  buttons: {
    color: "#fff",
    fontSize: "13px",
    height: "34px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  filterbuttons: {
    fontSize: "13px",
    height: "33px",
    width: "33px",
    maxHeight: 33,
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  listButtonsStyles: {
    fontSize: "18px",
    height: "34px",
    width: "34px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
  },
  listWhatsButtonsStyles: {
    fontSize: "13px",
    height: "29px",
    gap: 5,
    width: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
  },
  navButtonsStyles: {
    fontSize: "15px",
    height: "34px",
    minWidth: "34px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
  },
  iconStyles: {
    fontSize: 12,
    color: "#fff",
  },
  emptyDivs: {
    borderRight: "1px solid #E0E4F8",
    height: "35px",
    margin: "0px 2px",
  },
  DropdownItemsStyle: {
    fontSize: ".93re",
    letterSpacing: ".0386rem",
    fontWeight: 400,
    color: "#2e384d",
  },
  navLinksStyle: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "1px solid #E0E4F8",
    fontSize: 14,
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  inActiveNavLinksStyle: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "1px solid #E0E4F8",
    fontSize: 14,
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,
    lineHeight: 1.5,
    pointerEvents: "none",
  },
  tabContainer: {
    border: "1px solid #E0E4F8",
    borderRadius: "4px",
  },
  stickyHeader: {
    paddingBottom: "12px",
    paddingTop: "12px",
    position: "sticky",
    background: "#fff",
    top: "0px",
    background: "#fff",
    borderRadius: 0,
    borderBottom: "1px solid rgb(224, 228, 248)",
    borderTop: "1px solid rgb(224, 228, 248)",
    borderLeft: "1px solid rgb(224, 228, 248)",
    borderRight: "1px solid rgb(224, 228, 248)",
    zIndex: 1,
  },
  labels: {
    fontSize: "12px",
    color: "#B0BAC9",
    fontWeight: 400,
  },
  iconsStyles: {
    color: "#2656a8",
    border: "1px solid #e6e6e6",
    background: "#e9f1ff",
    padding: "8px",
    borderRadius: "50%",
    marginRight: "10px",
    width: "11px",
    height: "11px",
    fontSize: "13px",
  },
  values: {
    color: "#2e384d",
    fontWeight: 400,
    fontSize: ".8333rem",
    letterSpacing: "0.25px",
  },
  sectionTitle: {
    fontSize: "17px",
    fontWeight: 300,
    marginLeft: "14px",
    marginBottom: "19px",
  },
};


// const defaultd = { fullName: fullName, email: email, id: dealId }
